import { render } from "./YoutubeFormInput.vue?vue&type=template&id=eb210572&scoped=true&ts=true"
import script from "./YoutubeFormInput.vue?vue&type=script&lang=ts"
export * from "./YoutubeFormInput.vue?vue&type=script&lang=ts"

import "./YoutubeFormInput.vue?vue&type=style&index=0&id=eb210572&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb210572"]])

export default __exports__